export default __webpack_public_path__ + "static/media/karyawan.76ea87da.png";